import React, { useState } from "react";
import "./TopValue.css";
import { formatter2 } from "../../../../utils/helpers";
import {
  areaElementClasses,
  lineElementClasses,
  SparkLineChart,
} from "@mui/x-charts";
import { AmountCountAvg } from "../AmountCountAvg/AmountCountAvg";
import { Button , ArrowBigRight } from "../../../ui";

export const TopValue = ({ data }) => {
  const [isTop, setIsTop] = useState(true);
  const hasData = data && data.length > 0;
  const displayData = hasData ? data : [{ value: 0 }];

  const getDisplayValue = (item) => item?.value ?? 0;
  const sparkData = displayData
    .slice()
    .reverse()
    .map((item) => getDisplayValue(item));

  return (
    <div className="top-value-container">
      {isTop ? (
        <div className="top-values">
          <SparkLineChart
            data={sparkData.length === 1 ? [0, ...sparkData] : sparkData}
            height={150}
            width={100}
            area
            color="#4a0d66" // primary color, can be dynamic
            baseline="zero"
            showHighlight
            sx={{
              [`& .${lineElementClasses.root}`]: { strokeWidth: 2 },
              [`& .${areaElementClasses.root}`]: {
                fill: "rgba(74, 13, 102, 0.15)", // transparent area
                stroke: "none",
              },
            }}
          />

          <div className="top-value">
            <div className="top-value-item-col">
              <p>{displayData[0]?.label && displayData[0].label}</p>
              <p>{formatter2.format(getDisplayValue(displayData[0]))}</p>
            </div>
            {displayData.map((item, idx) => {
              if (idx !== 0) {
                return (
                  <div key={idx} className="top-value-item">
                    <p className="top-value-label">
                      {item?.label && <span>{item.label}</span>}
                      {formatter2.format(getDisplayValue(item))}
                    </p>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      ) : (
        <AmountCountAvg data={data} />
      )}
      <div className="top-value-buttons">
       <Button
  type="button"
  variant={isTop ? "primary" : "secondary"}
  appearance={isTop ? "filled" : "soft"}
  size="sm"
  icon={<ArrowBigRight size={16} />}
  onClick={() => setIsTop((prev) => !prev)}
/>
      </div>
    </div>
  );
};
